<template>
    <div class="w-ful p-5 cursor-pointer border transition duration-300 group" :class="buttonTheme">
        <p v-if="type == 'default' && !loading" :class="textTheme" class="font-bold pointer-events-none">{{ text }}</p>
        <div v-if="type == 'step' && !loading" class="flex w-full text-left">
            <p class="font-bold pointer-events-none" :class="textTheme">{{ text }}</p>
            <svg :class="svgTheme" class="mt-1 ml-auto transition-all duration-300" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path d="M17.3172 10.4422L11.6922 16.0672C11.5749 16.1845 11.4159 16.2504 11.25 16.2504C11.0841 16.2504 10.9251 16.1845 10.8078 16.0672C10.6905 15.9499 10.6247 15.7909 10.6247 15.625C10.6247 15.4592 10.6905 15.3001 10.8078 15.1828L15.3664 10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.442C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83425 2.56585 9.67528 2.68306 9.55807C2.80027 9.44086 2.95924 9.37501 3.125 9.37501H15.3664L10.8078 4.8172C10.6905 4.69992 10.6247 4.54086 10.6247 4.37501C10.6247 4.20916 10.6905 4.0501 10.8078 3.93282C10.9251 3.81555 11.0841 3.74966 11.25 3.74966C11.4159 3.74966 11.5749 3.81555 11.6922 3.93282L17.3172 9.55782C17.3753 9.61587 17.4214 9.6848 17.4529 9.76067C17.4843 9.83655 17.5005 9.91788 17.5005 10C17.5005 10.0821 17.4843 10.1635 17.4529 10.2393C17.4214 10.3152 17.3753 10.3842 17.3172 10.4422Z"/>
            </svg>
        </div>
        <Loader v-if="loading" class="mt-1"></Loader>
    </div>
</template>

<script setup lang="ts">
const route = ref('test');
const props = withDefaults(
    defineProps<{
        text?: string;
        type?: 'default' | 'step';
        loading?: boolean;
    }>(),
    {
        text: '',
        type: 'default',
        loading: false
    }
);

onMounted(() => {
    route.value = window.location.origin;
})

const buttonTheme = computed(() => {
    if (route.value.includes('nordvaerk')) {
        return 'border-white bg-white hover:bg-primary'
    } else if (route.value.includes('bibliotek')) {
        return 'border-white bg-white hover:bg-bib'
    } else {
        return 'border-white bg-white hover:bg-primary'
    }
});

const textTheme = computed(() => {
    if (route.value.includes('nordvaerk')) {
        return 'text-primary group-hover:text-white'
    } else if (route.value.includes('bibliotek')) {
        return 'text-bib group-hover:text-white'
    } else {
        return 'text-primary group-hover:text-white'
    }
});

const svgTheme = computed(() => {
    if (route.value.includes('nordvaerk')) {
        return 'fill-primary group-hover:fill-white'
    } else if (route.value.includes('bibliotek')) {
        return 'fill-bib group-hover:fill-white'
    } else {
        return 'fill-primary group-hover:fill-white'
    }
});



</script>